'use client';

import { SlOptionsVertical } from 'react-icons/sl';

import { Tooltip } from '../Tooltip';

// ! DO NOT use this component directly. Use the **OptionsMenu** component instead.

type OptionsButtonProps = {
  ariaLabel: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export function OptionsButton({
  ariaLabel,
  onClick = () => {},
}: OptionsButtonProps) {
  return (
    <Tooltip title="More options">
      <button
        tabIndex={0}
        type="button"
        className="button-base"
        aria-label={ariaLabel}
        onClick={onClick}
        style={{
          backgroundColor: 'var(--nn-color-secondary)',
          border: '1px solid var(--nn-color-input-border)',
          width: '2rem',
          height: '2rem',
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <SlOptionsVertical
          size={13}
          color="var(--nn-color-interactive)"
          aria-hidden
        />
      </button>
    </Tooltip>
  );
}
